import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from?.pathname || "/forum";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(form.email, form.password);
      toast.success("Hoş geldin!");
      navigate(from, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Giriş yapılamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="k-container grid place-items-center py-16 md:py-24">
      <div className="w-full max-w-md">
        <h1 className="font-display text-6xl text-ink-900 text-center" data-testid="login-title">
          Tekrar hoş geldin
        </h1>
        <p className="mt-2 text-center font-body text-ink-700">Kabileye devam etmek için giriş yap.</p>

        <div className="k-card mt-8 p-8">
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="k-label">E-posta</label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                className="k-input"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="sen@ornek.com"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="k-label">Şifre</label>
              <input
                data-testid="login-password-input"
                type="password"
                required
                minLength={6}
                className="k-input"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div
                className="rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={busy}
              className="k-btn-primary w-full disabled:opacity-60"
              data-testid="login-submit-btn"
            >
              {busy ? "Giriş yapılıyor…" : "Giriş yap"}
            </button>
          </form>

          <div className="my-6 flex items-center gap-3 text-xs text-ink-500">
            <div className="k-divider" />
            veya
            <div className="k-divider" />
          </div>

          <button
            onClick={startGoogleLogin}
            className="w-full rounded-full border border-cream-300 bg-cream-50 px-6 py-3 font-semibold text-ink-900 transition-colors hover:bg-cream-200"
            data-testid="google-login-btn"
          >
            Google ile giriş yap
          </button>

          <p className="mt-6 text-center font-body text-sm text-ink-700">
            İlk kez mi buradasın?{" "}
            <Link to="/register" className="font-bold text-sage-700 hover:underline" data-testid="login-to-register">
              Kabileye katıl
            </Link>
          </p>
          <p className="mt-3 text-center font-body text-xs text-ink-500">
            Sorular için:{" "}
            <a href="mailto:kabilewaldorf@gmail.com" className="text-sage-700 hover:underline">
              kabilewaldorf@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
